import React from 'react';
import Loadable from 'react-loadable';

const LoadableComponent = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'comparewidgetdesktop' */ './CompareWidget'),
  loading: () => null,
});

class CompareWidgetLoader extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  componentDidMount() {
    setTimeout(() => {
      this.setState({ load: true });
    }, 1000);
  }

  render() {
    if (!this.state.load) {
      return null;
    }
    return <LoadableComponent {...this.props} />;
  }
}

export default CompareWidgetLoader;
